<template>
    <sa-page-layout :toolbarVisible="false" :btnSaveVisible="false" :btnAnnullaVisible="false" :linkback="linkback" :data="jsonData" :showModalLoading="showModalLoading" :pathResource="pathResource" class="sa-no-space">
        <template slot="table-body">
            <identity-test-component @befoarLoadData="befoarLoadData" @afterLoadData="afterLoadData"></identity-test-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import IdentityTestComponent from "../components/IdentityTestComponent.vue";
export default {
    components: { SaPageLayout, IdentityTestComponent },
    data() {
        return {
            linkback: null,
            jsonData: {},
            showModalLoading: false,
            pathResource: null,
        };
    },
    methods: {
        befoarLoadData() {
            this.showModalLoading = true;
        },
        afterLoadData() {
            this.showModalLoading = false;
        },
    },
};
</script>

<style></style>
